import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { getYearRenderMode } from '../../common/utils/getYearRenderMode';
import ensureCommunityRewind from '../utils/ensureCommunityRewind';
export default class ProfileRewindPage extends UserPage {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "generating", false);
    _defineProperty(this, "snapshots", []);
    _defineProperty(this, "isDestroyed", false);
    _defineProperty(this, "savingPublic", false);
  }
  onremove(vnode) {
    this.isDestroyed = true;
    super.onremove(vnode);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
  }
  show(user) {
    super.show(user);
    this.loadSnapshots(user);
  }
  isOwner() {
    return !!(app.session.user && this.user && app.session.user.id() === this.user.id());
  }
  async loadSnapshots(user) {
    this.loading = true;
    m.redraw();
    try {
      const response = await app.store.find('rw-snaps', {
        filter: {
          user: user.id()
        },
        sort: '-year',
        fields: {
          'rw-snaps': 'year,generatedAt,isPublic,canEdit,canModerate,isEmpty'
        }
      });
      this.snapshots = Array.isArray(response) ? response : [response];
    } catch {
      this.snapshots = [];
    }
    this.loading = false;
    m.redraw();
  }
  openSlideshow(snapshot) {
    const renderMode = getYearRenderMode(snapshot.year());
    if (renderMode === 'blade') {
      const baseUrl = app.forum.attribute('baseUrl') || '';
      window.location.href = `${baseUrl}/rewind/view/${this.user.id()}/${snapshot.year()}`;
    } else {
      m.route.set(app.route('huseyinfiliz-rewind.slideshow', {
        id: this.user.id(),
        year: snapshot.year()
      }));
    }
  }
  async generateAndOpen() {
    this.generating = true;
    m.redraw();
    try {
      await ensureCommunityRewind(app.forum.attribute('rewindActiveYear'), () => this.isDestroyed);
      if (this.isDestroyed) return;
      await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/rw-snaps/generate'
      });
      const year = app.forum.attribute('rewindActiveYear');
      const refetched = await app.store.find('rw-snaps', {
        filter: {
          user: this.user.id(),
          year
        }
      });
      const results = Array.isArray(refetched) ? refetched : [refetched];
      const snapshot = results.length > 0 ? results[0] : null;
      await this.loadSnapshots(this.user);
      if (snapshot) {
        this.openSlideshow(snapshot);
        return;
      }
    } catch (e) {
      const msg = e?.responseJSON?.errors?.[0]?.detail || 'Failed to generate rewind';
      app.alerts.show({
        type: 'error'
      }, msg);
    }
    this.generating = false;
    m.redraw();
  }
  async togglePublic(snapshot) {
    if (!snapshot || this.savingPublic) return;
    this.savingPublic = true;
    m.redraw();
    try {
      await snapshot.save({
        isPublic: !snapshot.isPublic()
      });
    } catch (e) {
      console.error('Failed to toggle visibility:', e);
    }
    this.savingPublic = false;
    m.redraw();
  }
  async regenerateSnapshot(snapshot) {
    this.generating = true;
    m.redraw();
    try {
      await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/rw-snaps/generate'
      });
      await this.loadSnapshots(this.user);
    } catch (e) {
      const msg = e?.responseJSON?.errors?.[0]?.detail || 'Failed to regenerate';
      app.alerts.show({
        type: 'error'
      }, msg);
    }
    this.generating = false;
    m.redraw();
  }
  async deleteSnapshot(snapshot) {
    if (!confirm(app.translator.trans('huseyinfiliz-rewind.forum.profile.controls.confirm_delete'))) {
      return;
    }
    try {
      await snapshot.delete();
      this.snapshots = this.snapshots.filter(s => s.id() !== snapshot.id());
      m.redraw();
    } catch (e) {
      const msg = e?.responseJSON?.errors?.[0]?.detail || 'Failed to delete';
      app.alerts.show({
        type: 'error'
      }, msg);
    }
  }
  content() {
    const canView = app.forum.attribute('canViewRewind');
    const canModerate = app.forum.attribute('canModerateRewind');
    const enabled = app.forum.attribute('rewindEnabled');
    if (!(enabled && canView) && !canModerate) {
      return m("div", {
        className: "RewindView-empty"
      }, m("p", null, app.translator.trans('huseyinfiliz-rewind.forum.page.not_available')));
    }
    if (this.loading || this.generating) {
      return m("div", {
        className: "RewindView-loading"
      }, m(LoadingIndicator, null), this.generating && m("p", null, app.translator.trans('huseyinfiliz-rewind.forum.page.generating')));
    }
    return this.renderGrid();
  }
  renderGrid() {
    const user = this.user;
    const isOwner = this.isOwner();
    const year = app.forum.attribute('rewindActiveYear');
    const hasActiveYear = this.snapshots.some(s => s.year() === year);
    const canGenerate = app.forum.attribute('canGenerateRewind');
    return m("div", {
      className: "RewindGrid"
    }, m("div", {
      className: "RewindGrid-cards"
    }, isOwner && !hasActiveYear && canGenerate && m("div", {
      className: "RewindGrid-card RewindGrid-card--generate",
      onclick: () => this.generateAndOpen()
    }, m("div", {
      className: "RewindGrid-cardLink"
    }, m("div", {
      className: "RewindGrid-cardIcon RewindGrid-cardIcon--generate"
    }, m("i", {
      className: "fas fa-play"
    })), m("div", {
      className: "RewindGrid-cardBody"
    }, m("div", {
      className: "RewindGrid-cardYear"
    }, year), m("div", {
      className: "RewindGrid-cardMeta"
    }, m("span", {
      className: "RewindGrid-cardBadge generate"
    }, app.translator.trans('huseyinfiliz-rewind.forum.profile.tap_to_watch')))))), isOwner && !hasActiveYear && !canGenerate && m("div", {
      className: "RewindGrid-card RewindGrid-card--locked"
    }, m("div", {
      className: "RewindGrid-cardLink"
    }, m("div", {
      className: "RewindGrid-cardIcon RewindGrid-cardIcon--locked"
    }, m("i", {
      className: "fas fa-lock"
    })), m("div", {
      className: "RewindGrid-cardBody"
    }, m("div", {
      className: "RewindGrid-cardYear"
    }, year), m("div", {
      className: "RewindGrid-cardMeta"
    }, m("span", {
      className: "RewindGrid-cardBadge locked"
    }, app.translator.trans('huseyinfiliz-rewind.forum.profile.not_yet_available')))))), !isOwner && !hasActiveYear && m("div", {
      className: "RewindGrid-card RewindGrid-card--locked"
    }, m("div", {
      className: "RewindGrid-cardLink"
    }, m("div", {
      className: "RewindGrid-cardIcon RewindGrid-cardIcon--locked"
    }, m("i", {
      className: "fas fa-lock"
    })), m("div", {
      className: "RewindGrid-cardBody"
    }, m("div", {
      className: "RewindGrid-cardYear"
    }, year), m("div", {
      className: "RewindGrid-cardMeta"
    }, m("span", {
      className: "RewindGrid-cardBadge locked"
    }, app.translator.trans('huseyinfiliz-rewind.forum.profile.not_yet_available')))))), this.snapshots.map(snapshot => {
      const empty = snapshot.isEmpty();
      const isPrivate = !snapshot.isPublic();
      const canView = isOwner || !isPrivate || snapshot.canModerate?.();
      const locked = empty || !canView && isPrivate;
      return m("div", {
        className: 'RewindGrid-card' + (locked ? ' RewindGrid-card--locked' : ''),
        key: snapshot.id()
      }, locked ? m("div", {
        className: "RewindGrid-cardLink"
      }, m("div", {
        className: "RewindGrid-cardIcon RewindGrid-cardIcon--locked"
      }, m("i", {
        className: empty ? 'fas fa-ghost' : 'fas fa-lock'
      })), m("div", {
        className: "RewindGrid-cardBody"
      }, m("div", {
        className: "RewindGrid-cardYear"
      }, snapshot.year()), m("div", {
        className: "RewindGrid-cardMeta"
      }, m("span", {
        className: "RewindGrid-cardBadge locked"
      }, empty ? app.translator.trans('huseyinfiliz-rewind.forum.profile.no_activity') : app.translator.trans('huseyinfiliz-rewind.forum.profile.not_yet_available'))))) : m("a", {
        className: "RewindGrid-cardLink",
        href: "#",
        onclick: e => {
          e.preventDefault();
          this.openSlideshow(snapshot);
        }
      }, m("div", {
        className: "RewindGrid-cardIcon"
      }, m("i", {
        className: "fas fa-history"
      })), m("div", {
        className: "RewindGrid-cardBody"
      }, m("div", {
        className: "RewindGrid-cardYear"
      }, snapshot.year()), m("div", {
        className: "RewindGrid-cardMeta"
      }, m("span", {
        className: `RewindGrid-cardBadge ${isPrivate ? 'private' : 'public'}`
      }, m("i", {
        className: isPrivate ? 'fas fa-lock' : 'fas fa-globe-americas'
      }), isPrivate ? app.translator.trans('huseyinfiliz-rewind.forum.profile.private_badge') : app.translator.trans('huseyinfiliz-rewind.forum.profile.public_badge'))))), snapshot.canEdit() && m(Dropdown, {
        className: "RewindGrid-cardControls",
        buttonClassName: "Button Button--icon Button--flat",
        icon: "fas fa-ellipsis-v"
      }, m(Button, {
        icon: snapshot.isPublic() ? 'fas fa-eye-slash' : 'fas fa-eye',
        onclick: () => this.togglePublic(snapshot)
      }, snapshot.isPublic() ? app.translator.trans('huseyinfiliz-rewind.forum.profile.controls.make_private') : app.translator.trans('huseyinfiliz-rewind.forum.profile.controls.make_public')), snapshot.canModerate() && m(Button, {
        icon: "fas fa-sync",
        onclick: () => this.regenerateSnapshot(snapshot)
      }, app.translator.trans('huseyinfiliz-rewind.forum.profile.controls.regenerate')), snapshot.canModerate() && m(Button, {
        icon: "fas fa-trash",
        onclick: () => this.deleteSnapshot(snapshot)
      }, app.translator.trans('huseyinfiliz-rewind.forum.profile.controls.delete'))));
    })));
  }
}
flarum.reg.add('huseyinfiliz-rewind', 'forum/components/ProfileRewindPage', ProfileRewindPage);